// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../ProjectsPage.generated';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type HierarchyDashboardPage_ProjectsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ProjectFilter>;
  orderBy?: Types.InputMaybe<Types.ProjectOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type HierarchyDashboardPage_ProjectsQuery = { __typename?: 'Query', projectsPage: { __typename?: 'ProjectsPageResult', entities: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string, parent?:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
         | null | undefined, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
      | { __typename?: 'Region', id: string, name: string, parent?:
          | { __typename?: 'StandaloneProject', id: string }
          | { __typename?: 'Region', id: string }
          | { __typename?: 'Market', id: string }
          | { __typename?: 'Community', id: string }
          | { __typename?: 'Subdivision', id: string }
          | { __typename?: 'Lot', id: string }
          | { __typename?: 'Structure', id: string }
          | { __typename?: 'Unit', id: string }
         | null | undefined, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
      | { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
      | { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
      | { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
      | { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
      | { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
      | { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string }, parentsRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined }
    >, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type HierarchyDashboardPage_FilterOptionsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type HierarchyDashboardPage_FilterOptionsQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Region', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Market', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Community', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Subdivision', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Lot', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Structure', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Unit', childrenRecursive: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
   };

export type HierarchyDashboardPage_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, parent?:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
   | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, parent?:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
   | null | undefined, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, parent: { __typename?: 'Region', id: string }, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, parent: { __typename?: 'Market', id: string }, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, parent: { __typename?: 'Community', id: string }, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, parent: { __typename?: 'Subdivision', id: string }, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, parent: { __typename?: 'Lot', id: string }, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, parent: { __typename?: 'Structure', id: string }, parentsRecursive: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, globalOption: { __typename?: 'GlobalOption', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }> } | null | undefined };

export type HierarchyDashboardPage_ProjectFragment =
  | HierarchyDashboardPage_Project_StandaloneProject_Fragment
  | HierarchyDashboardPage_Project_Region_Fragment
  | HierarchyDashboardPage_Project_Market_Fragment
  | HierarchyDashboardPage_Project_Community_Fragment
  | HierarchyDashboardPage_Project_Subdivision_Fragment
  | HierarchyDashboardPage_Project_Lot_Fragment
  | HierarchyDashboardPage_Project_Structure_Fragment
  | HierarchyDashboardPage_Project_Unit_Fragment
;

export const HierarchyDashboardPage_ProjectFragmentDoc = gql`
    fragment HierarchyDashboardPage_Project on Project {
  ...Named
  parent {
    id
  }
  parentsRecursive {
    ...Named
  }
  readyPlanConfig {
    id
    readyPlanOptions(forDesignPackages: true) {
      ...Named
      globalOption {
        id
        group {
          id
          type {
            id
            name
          }
        }
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const HierarchyDashboardPage_ProjectsDocument = gql`
    query HierarchyDashboardPage_Projects($filter: ProjectFilter, $orderBy: ProjectOrder, $page: PageFilter) {
  projectsPage(filter: $filter, orderBy: $orderBy, page: $page) {
    entities {
      ...HierarchyDashboardPage_Project
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${HierarchyDashboardPage_ProjectFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useHierarchyDashboardPage_ProjectsQuery__
 *
 * To run a query within a React component, call `useHierarchyDashboardPage_ProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyDashboardPage_ProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyDashboardPage_ProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useHierarchyDashboardPage_ProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>(HierarchyDashboardPage_ProjectsDocument, options);
      }
export function useHierarchyDashboardPage_ProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>(HierarchyDashboardPage_ProjectsDocument, options);
        }
// @ts-ignore
export function useHierarchyDashboardPage_ProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>;
export function useHierarchyDashboardPage_ProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HierarchyDashboardPage_ProjectsQuery | undefined, HierarchyDashboardPage_ProjectsQueryVariables>;
export function useHierarchyDashboardPage_ProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>(HierarchyDashboardPage_ProjectsDocument, options);
        }
export type HierarchyDashboardPage_ProjectsQueryHookResult = ReturnType<typeof useHierarchyDashboardPage_ProjectsQuery>;
export type HierarchyDashboardPage_ProjectsLazyQueryHookResult = ReturnType<typeof useHierarchyDashboardPage_ProjectsLazyQuery>;
export type HierarchyDashboardPage_ProjectsSuspenseQueryHookResult = ReturnType<typeof useHierarchyDashboardPage_ProjectsSuspenseQuery>;
export type HierarchyDashboardPage_ProjectsQueryResult = ApolloReactCommon.QueryResult<HierarchyDashboardPage_ProjectsQuery, HierarchyDashboardPage_ProjectsQueryVariables>;
export const HierarchyDashboardPage_FilterOptionsDocument = gql`
    query HierarchyDashboardPage_FilterOptions($projectId: ID!) {
  project(id: $projectId) {
    childrenRecursive {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useHierarchyDashboardPage_FilterOptionsQuery__
 *
 * To run a query within a React component, call `useHierarchyDashboardPage_FilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchyDashboardPage_FilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHierarchyDashboardPage_FilterOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useHierarchyDashboardPage_FilterOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables> & ({ variables: HierarchyDashboardPage_FilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>(HierarchyDashboardPage_FilterOptionsDocument, options);
      }
export function useHierarchyDashboardPage_FilterOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>(HierarchyDashboardPage_FilterOptionsDocument, options);
        }
// @ts-ignore
export function useHierarchyDashboardPage_FilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>;
export function useHierarchyDashboardPage_FilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HierarchyDashboardPage_FilterOptionsQuery | undefined, HierarchyDashboardPage_FilterOptionsQueryVariables>;
export function useHierarchyDashboardPage_FilterOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>(HierarchyDashboardPage_FilterOptionsDocument, options);
        }
export type HierarchyDashboardPage_FilterOptionsQueryHookResult = ReturnType<typeof useHierarchyDashboardPage_FilterOptionsQuery>;
export type HierarchyDashboardPage_FilterOptionsLazyQueryHookResult = ReturnType<typeof useHierarchyDashboardPage_FilterOptionsLazyQuery>;
export type HierarchyDashboardPage_FilterOptionsSuspenseQueryHookResult = ReturnType<typeof useHierarchyDashboardPage_FilterOptionsSuspenseQuery>;
export type HierarchyDashboardPage_FilterOptionsQueryResult = ApolloReactCommon.QueryResult<HierarchyDashboardPage_FilterOptionsQuery, HierarchyDashboardPage_FilterOptionsQueryVariables>;